import { makeAutoObservable } from "mobx";
import { CancelMarketingDTO, DeleteRestingPlaceDTO, DetailMarketingDTO, MarketingDTO, ProductDTO, RestingPlaceDTO, RestingPlaceListDTO, UpdateProductOrderDTO, UpdateRetrofitDTO } from "../models/models";
import agent from "../api/agent";

export default class RetrofitStore {

    products: ProductDTO | undefined = undefined;

    loadingInitial = false;
    modalLoadingInitial = false;

    constructor() {
        makeAutoObservable(this);
    }
    setLoadingInitial = (val: boolean) => {
        this.loadingInitial = val;
    }
    setModalLoadingInitial = (val: boolean) => {
        this.modalLoadingInitial = val;
    }

    loadProducts = async () => {
        this.setModalLoadingInitial(true);
        try {
            const result = await agent.Product.list();
            if (result) {
                this.products = JSON.parse(JSON.stringify(result));
                return true
            }
            else
                return false;
        } catch (error) {
            //console.log(error);
            return false;
        }
        finally {
            this.setModalLoadingInitial(false);
        }
    }

    cancelProduct = async (product: CancelMarketingDTO) => {
        this.setModalLoadingInitial(true);
        try {
            var res = await agent.Product.cancelProduct(product);
            return res;
        } catch (error) {
            //console.log(error);
            return null;
        }
        finally {
            this.setModalLoadingInitial(false);
        }
    }




    getProductDetail = async (id: string): Promise<ProductDTO | null> => {
        this.setModalLoadingInitial(true);
        try {
            const result = await agent.Product.detail(id);
            return result;
        } catch (error) {
            //console.log(error);
            return null;
        }
        finally {
            this.setModalLoadingInitial(false);
        }
    }


    
    createProduct = async (product: FormData) => {
        try {
            return await agent.Product.createProduct(product);
        } catch (error) {
            //console.log(error);
            return false;
        }
    }

    updateProductOrder = async (productOrder: UpdateProductOrderDTO) => {
        try {
            var res = await agent.Product.updateOrder(productOrder);
            return res;
        } catch (error) {
            //console.log(error);
            return false;
        }

    }

    updateRetrofit = async (productOrder: FormData) => {
        try {
            var res = await agent.Product.updateRetrofit(productOrder);
            return res;
        } catch (error) {
            //console.log(error);
            return false;
        }

    }
}